import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'windrose' })
export class WindrosePipe implements PipeTransform {
  transform(input, parts?: number, long = false): any {
    if (!parts) {
      parts = 8;
    }
    const dd = parseInt(input, 10);
    const factor: number = 360 / parts;

    const translationKey = long ? 'WINDROSE_LONG.' : 'WINDROSE.';
    return translationKey + Math.floor((dd + factor / 2) / factor) * factor;
  }
}
